import { render, staticRenderFns } from "./l-chirurgie.html?vue&type=template&id=320f1924&scoped=true&external"
import script from "./l-chirurgie.js?vue&type=script&lang=js&external"
export * from "./l-chirurgie.js?vue&type=script&lang=js&external"
import style0 from "./l-chirurgie.scss?vue&type=style&index=0&id=320f1924&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f1924",
  null
  
)

export default component.exports